import request from '../../request';

const moment = window.moment;

export default {
  namespaced: true,
  state: {
    loading: false,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().add(1, 'w').format('YYYY-MM-DD'),
    activities: [],
    location: { value: 1, label: 'Portugal' },
  },
  mutations: {
    setLoading(state, payload) {
      Object.assign(state, { loading: payload });
    },
    setSearchResults(state, payload) {
      Object.assign(state, { activities: payload });
    },
    setStartDate(state, payload) {
      const date = moment(payload).format('YYYY-MM-DD');
      Object.assign(state, { startDate: date });
    },
    setEndDate(state, payload) {
      const date = moment(payload).format('YYYY-MM-DD');
      Object.assign(state, { endDate: date });
    },
    setLocation(state, payload) {
      Object.assign(state.location, payload);
    },
    setFullState(state, payload) {
      Object.assign(state, payload);
    },
  },
  actions: {
    setDates(context, payload) {
      return new Promise((resolve) => {
        context.commit('setStartDate', payload.start);
        context.commit('setEndDate', payload.end);
        resolve();
      });
    },
    get(context, payload) {
      context.commit('setLoading', true);
      context.dispatch('showWaiting', null, { root: true });
      if (typeof payload.startDate !== 'undefined') {
        context.commit('setStartDate', payload.startDate);
      }
      if (typeof payload.endDate !== 'undefined') {
        context.commit('setEndDate', payload.endDate);
      }
      if (typeof payload.location !== 'undefined') {
        context.dispatch('setLocation', { label: null, value: payload.location });
      }

      const startDate = context.state.startDate;
      const endDate = context.state.endDate;
      const data = {
        between: `${startDate}|${endDate}`,
        location: payload.location,
      };

      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity`,
        data,
      }, (err, res) => {
        context.dispatch('saveToStorage');
        context.dispatch('hideWaiting', null, { root: true });
        context.commit('setLoading', false);
        if (res.status === 200) {
          context.commit('setSearchResults', res.body.data);
        } else if (res.status === 404) {
          context.commit('setSearchResults', []);
        }
      });
    },
    setSearchStartDate(context, payload) {
      context.commit('setStartDate', payload);
      if (moment(payload).isAfter(context.state.endDate, 'day')) {
        context.commit('setEndDate', payload);
      }
    },
    setSearchEndDate(context, payload) {
      context.commit('setEndDate', payload);
      if (moment(payload).isBefore(context.state.startDate, 'day')) {
        context.commit('setStartDate', payload);
      }
    },
    setLocation(context, payload) {
      if (typeof payload.label === 'undefined' || payload.label === null) {
        const loc = context.rootState.locations.data.locations.find(location =>
          location.id === parseInt(payload.value, 10));
        if (typeof loc !== 'undefined') {
          context.commit('setLocation', { label: loc.name, value: payload.value });
        } else {
          context.commit('setLocation', { label: null, value: payload.value });
        }
      } else {
        context.commit('setLocation', payload);
      }
    },
    saveToStorage(context) {
      sessionStorage.setItem('search', JSON.stringify(context.state));
    },
    loadFromStorage(context) {
      const stateString = sessionStorage.getItem('search');
      if (stateString !== null) {
        context.commit('setFullState', JSON.parse(stateString));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/public/search.js